import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Form } from 'components';
import { positiveDoublePattern } from 'utils';
import { wrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FundsDepositForm = function FundsDepositForm(_ref) {
  var onDeposit = _ref.onDeposit,
      label = _ref.label,
      placeholder = _ref.placeholder,
      addButtonText = _ref.addButtonText,
      takeButtonText = _ref.takeButtonText;
  var formRef = useRef();

  var handleSubmit = function handleSubmit(_ref2) {
    var values = _ref2.values,
        e = _ref2.e;
    return _isFunction(onDeposit) && onDeposit(values, e.target.id);
  };

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    css: wrap,
    ref: formRef
  }, ___EmotionJSX(Input, {
    formId: "amount",
    className: "deposit-input",
    label: label,
    small: true,
    placeholder: placeholder,
    pattern: positiveDoublePattern,
    validate: function validate(val) {
      return (val <= 0 || !val) && {
        msg: 'Въведете положително число!'
      };
    },
    number: true
  }), function (_ref3) {
    var onSubmit = _ref3.onSubmit;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
      id: "add",
      type: "success",
      small: true,
      onClick: onSubmit,
      margin: "0 1em 0 0"
    }, addButtonText), ___EmotionJSX(Button, {
      id: "take",
      type: "danger",
      small: true,
      onClick: onSubmit
    }, takeButtonText));
  });
};

FundsDepositForm.propTypes = {
  onDeposit: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  addButtonText: PropTypes.string,
  takeButtonText: PropTypes.string
};
export default FundsDepositForm;